import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled, { ThemeContext } from "styled-components";

import PopoverWrapper from "../Gallery/Popover";
import { CategoriesBar } from "./CategoriesBar";
import { getSelectedGuideCategory } from "./selectors";
import { LocationCard } from "./LocationCard";
import { Arrow, GalleryNavArrow } from "../../lib/icons";
import { categories, getCardsData } from "./utils";
import { urlConfig } from "../../lib/utils";
import { plotRoute, switchCategory, setView } from "./actions";
import { goToModule } from "../../actions";
import { getChatPk, getFacilityCoordinates } from "../../store";

const saveIframeRef = (ref) => {
  window.geoIframe = ref?.contentWindow;
};

export const Guide = () => {
  const selectedCategory = useSelector(getSelectedGuideCategory);
  const chatID = useSelector(getChatPk);
  const startPos = useSelector(getFacilityCoordinates);
  const cardsData = getCardsData(chatID, selectedCategory);
  const dispatch = useDispatch();

  useEffect(() => {
    plotRoute(startPos, getCardsData(chatID, selectedCategory)[0].coordinates);
  }, [chatID, selectedCategory, startPos]);

  const onIframeLoad = () => {
    setView(startPos);
    plotRoute(startPos, cardsData[0].coordinates);
  };

  const gotoNextCategory = () => {
    const currentIndex = categories.findIndex((c) => c === selectedCategory);
    const newIndex = currentIndex === categories.length - 1 ? 0 : currentIndex + 1;
    dispatch(switchCategory(categories[newIndex]));
  };

  const gotoPrevCategory = () => {
    const currentIndex = categories.findIndex((c) => c === selectedCategory);
    const newIndex = currentIndex === 0 ? categories.length - 1 : currentIndex - 1;
    dispatch(switchCategory(categories[newIndex]));
  };

  const messagesEndRef = React.useRef(null);
  const scrollToBottom = () => {
    try {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    } catch (e) {
      console.log("fam: scrolling error"); // for jest tests.
    }
  };
  React.useEffect(scrollToBottom, [selectedCategory]);

  const iframeAddress = urlConfig.localIframe ? "http://localhost:8001" : "https://chat.scythargon.ru";

  const theme = useContext(ThemeContext);

  const goBackToChat = () => {
    dispatch(goToModule(1));
  };

  return (
    <PopoverWrapper>
      <GuideWrapper>
        <BackButton onClick={goBackToChat}>
          <Arrow className="arrow left" fillColor={theme.brandColor} /> Chat
        </BackButton>

        <Map>
          <iframe
            onLoad={onIframeLoad}
            ref={saveIframeRef}
            src={`${iframeAddress}/geo-demo/geo.html`}
            width="100%"
            height="342px"
          />
        </Map>
        <CategoriesBar />

        <NavCircle className="left" onClick={gotoPrevCategory}>
          <GalleryNavArrow className="nav-arrow left" />
        </NavCircle>

        <NavCircle onClick={gotoNextCategory}>
          <GalleryNavArrow className="nav-arrow right" />
        </NavCircle>

        <ScrollableContainer>
          <div ref={messagesEndRef} style={{ marginTop: "50px" }} />
          <CurrentCategoryHeader>{selectedCategory}</CurrentCategoryHeader>

          {cardsData.map((c, i) => (
            <LocationCard cardData={c} key={c.name} />
          ))}
        </ScrollableContainer>
      </GuideWrapper>
    </PopoverWrapper>
  );
};

const GuideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100vh;

  position: relative;
`;

const NavCircle = styled.div`
  background-color: white;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.12);
  position: absolute;
  color: #2f80ed;

  border-radius: 50%;
  width: 73px;
  height: 73px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  top: 606px;
  right: calc(50% - 551px);

  user-select: none;

  &.left {
    left: calc(50% - 551px);
  }

  transition: box-shadow 0.2s ease-in-out;
  &:hover {
    box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.2);
  }

  .nav-arrow {
    margin-left: 5px;

    &.left {
      margin-left: 0;
      margin-right: 5px;
    }

    &:hover {
      color: #2f80ed;
    }
  }

  &:hover .nav-arrow {
    transform: scale(1.1);

    &.left {
      transform: rotate(180deg) scale(1.1);
    }
  }
`;

const CurrentCategoryHeader = styled.div`
  font-weight: 900;
  font-size: 26px;
  text-align: center;

  margin-top: 26px;
`;

const ScrollableContainer = styled.div`
  padding: 18px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  align-items: center;

  user-select: none;

  flex: 1;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const Map = styled.div`
  background-color: lightgreen;
  height: 342px;
  min-height: 342px;
  max-height: 342px;
  width: 100vw;

  flex: 1;
`;

const BackButton = styled.div`
  position: absolute;
  top: 30px;
  left: 65px;
  padding: 10px 18px 8px;

  background: white;
  font-size: 20px;
  border-radius: 20px;
  color: ${(props) => props.theme.brandColor};
  cursor: pointer;

  &:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  .arrow {
    display: inline-block;
    vertical-align: middle;
    margin-right: 3px;
  }
`;
